module.exports = "<div class=holding-message> <h1> Your account is not active. </h1> <p> If you are new to the system, your administrator will activate your <br> account and notify you. </p> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/home/holding-home/holding-home.html
// module id = 388
// module chunks = 0